module.exports = __webpack_public_path__ + "static/infinity-logo-354ffc23168d984e6d0c06662f0f0714.gif";